import React from 'react';
import FavoriteOutlineIcon from '@moda/icons/favorite-outline-24';
import { Link } from '../Link';
import { QuickSearch } from '../QuickSearch';
import { MiniCart } from '../MiniCart';
import { hrefFor } from '../../routers';

import './DesktopSiteNavActions.scss';

export const DesktopSiteNavActions: React.FC = () => {
  return (
    <div className="DesktopSiteNavActions">
      <QuickSearch className="DesktopSiteNavActions__search" />

      <Link
        className="DesktopSiteNavActions__favorite"
        to={hrefFor.FavoritesPage()}
        aria-label="My Favorites"
      >
        <FavoriteOutlineIcon />
      </Link>

      <MiniCart />
    </div>
  );
};
